/*
 * archive-ps_howtos.js - page specific js code
 */

jQuery(document).ready(($) => {
    // keep filter menu anchored when scrolling
    $('#menu-filters-wrapper').stalker({
        stalkerStyle: 'menu-filters-wrapper-sticky',
    });

    $('#menu-filters-wrapper-mobile').stalker({
        stalkerStyle: 'menu-filters-wrapper-sticky',
    });

    // hover menu popup
    const $body = $('body');
    const closePopup = function ($filter) {
        $filter.trigger('mouseleave');
    };
    $('.menu-filter, .menu-filters-mobile-dropdown')
        .on('mouseenter touchstart', function () {
            const $this = $(this);
            $('.dropdown-filter', $this).css('max-height', $(window).height() - 215);
            if ($this.hasClass('menu-filters-mobile-dropdown') && PS_GLOBAL.isDevice) {
                $body.css('overflow', 'hidden');
            }
            $this.addClass('expanded');
        })
        .on('mouseleave', function () {
            const $this = $(this);
            $this.removeClass('expanded');
            if ($this.hasClass('menu-filters-mobile-dropdown') && PS_GLOBAL.isDevice) {
                $body.css('overflow', 'visible');
            }
        });

    // make same filter menus toggle via the keyboard
    $('.menu-filter, .menu-filters-mobile-dropdown').keydown(function (e) {
        if (e.keyCode === 9 || e.keyCode === 13) {
            // tab and return keys)
            const $this = $(this);
            $('.dropdown-filter', $this).css('max-height', $(window).height() - 215);
            if ($this.hasClass('menu-filters-mobile-dropdown') && PS_GLOBAL.isDevice) {
                $body.css('overflow', 'hidden');
            }
            $this.addClass('expanded');
        }
    });

    // use side arrows to jump from filter menus
    // NOTE: currently there are four and two column menus. If it's going to be changed,
    // indexPrevUp & indexNextDown need to be adjusted
    $('ul#menu-filters li.menu-filter ul.dropdown-filter li').keydown((e) => {
        const focused = $(':focus');
        const curIndex = focused.index();
        if (e.keyCode === 37) {
            // left
            e.preventDefault();
            // This is the first item
            if (focused.prev('li').length === 0) {
                focused.closest('li.menu-filter').find('a').first().focus();
            } else {
                focused.prev('li').focus();
            }
        } else if (e.keyCode === 38) {
            // up
            e.preventDefault();
            let indexPrevUp;
            if (focused.closest('li.menu-filter').hasClass('sort-by')) {
                indexPrevUp = curIndex - 2;
            } else {
                indexPrevUp = curIndex - 4;
            }
            if (indexPrevUp > 0) {
                // if it's first row, go to the menu header
                focused.closest('ul.dropdown-filter').find(`li:eq(${indexPrevUp})`).focus();
            } else {
                focused.closest('li.menu-filter').find('a').first().focus();
            }
        } else if (e.keyCode === 39) {
            // right
            e.preventDefault();
            // This is the last item
            console.log(focused);
            if (focused.next('li').length === 0) {
                focused.closest('li.menu-filter').next('li.menu-filter').find('a').first().focus(); // go to the next menu
            } else {
                focused.next('li').focus();
            }
        } else if (e.keyCode === 40) {
            // down
            e.preventDefault();
            const listLengt = focused.closest('ul.dropdown-filter').find('li').length;
            let indexNextDown;
            if (focused.closest('li.menu-filter').hasClass('sort-by')) {
                indexNextDown = curIndex + 2;
            } else {
                indexNextDown = curIndex + 4;
            }
            if (indexNextDown > listLengt) {
                focused.closest('li.menu-filter').next('li.menu-filter').find('a').first().focus();
            } else {
                focused.closest('ul.dropdown-filter').find(`li:eq(${indexNextDown})`).focus();
            }
        }
    });

    // close all open menus when hitting escape key
    $('.menu-filter, .menu-filters-mobile-dropdown').keydown((e) => {
        if (e.keyCode === 27 && $('.menu-filter, .menu-filters-mobile-dropdown').hasClass('expanded')) {
            $('.menu-filter, .menu-filters-mobile-dropdown').removeClass('expanded');
        }
    });

    // filtering
    // handle filter click on either ui
    $('#dropdown-mess,#dropdown-surface')
        .find('li')
        .on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            const value = $this.data('value');
            const text = $this.find('a').text();
            const $parent = $this.closest('.menu-filter');
            setFilter($parent.data('type'), value, text);
            closePopup($parent);
            filterChanged();
            return false;
        });

    // keyboard adds to filter menu
    $('#dropdown-mess,#dropdown-surface')
        .find('li')
        .on('keypress', function (e) {
            if (e.keyCode === 9) {
                // tab
                // e.preventDefault();
                const $this = $(this);
                const value = $this.data('value');
                const text = $this.find('a').text();
                const $parent = $this.closest('.menu-filter');
                setFilter($parent.data('type'), value, text);
                closePopup($parent);
                filterChanged();
                return false;
            }
            return undefined;
        });

    $('#dropdown-mess-mobile,#dropdown-surface-mobile')
        .find('li')
        .on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            const value = $this.data('value');
            const text = $this.find('a').text();
            // console.log('item click: '+value);
            const $parent = $this.closest('.panel');
            setFilter($parent.data('type'), value, text);
            closePopup($parent.closest('.menu-filters-mobile-dropdown'));
            filterChanged();
            return false;
        });

    const filters = {
        surface: $('.surface-filter'),
        mess: $('.mess-filter'),
    };
    // update values & both uis
    function setFilter(type, value, text) {
        const $parent = filters[type];
        $parent.data('value', value);
        $parent.find('.menu-filter-label-word').text(text);
        $parent.find('.menu-filter-mobile-label').text(text);
    }
    
    function filterChanged() {
        const surface = filters.surface.data('value');
        const mess = filters.mess.data('value');

        $('.howto').hide();
        let select = (surface ? `.surface-${surface}` : '') + (mess ? `.mess-${mess}` : '');
        if (!select) {
            select = '.howto';
        } else {
            $('.js-cta').hide();
        }
        $(select).show();
    }

    // clear filters
    $('#clear-form,#clear-form-mobile').on('click', (e) => {
        e.preventDefault();
        $.each(filters, (type) => {
            setFilter(type, '', type);
        });
        filterChanged();
    });

    // hitting the return key when the clean filter ul has focus will delete filters
    $('.reset-button').on('keydown', (e) => {
        if (e.keyCode === 13) {
            // return key
            $.each(filters, (type) => {
                setFilter(type, '', type);
            });
            filterChanged();
        }
    });

    // sorting
    const sortFunctions = {
        'a-z': function (a, b) {
            return $(a).find('.js-tile-id').text().localeCompare($(b).find('.js-tile-id').text());
        },
        'z-a': function (a, b) {
            return -$(a).find('.js-tile-id').text().localeCompare($(b).find('.js-tile-id').text());
        },
        numeric (a, b) {
            return +$(a).data('number') - +$(b).data('number');
        },
        'numeric-reverse': function (a, b) {
            return +$(b).data('number') - +$(a).data('number');
        },
        popular (a, b) {
            return +$(b).data('popular') - +$(a).data('popular');
        },
        videos (a, b) {
            return +$(b).data('videos') - +$(a).data('videos');
        },
        floor (a, b) {
            return +$(b).data('floor') - +$(a).data('floor');
        },
        'surprising-uses': function (a, b) {
            return +$(b).data('surprising-uses') - +$(a).data('surprising-uses');
        },
        'deep-cleaning': function (a, b) {
            return +$(b).data('deep-cleaning') - +$(a).data('deep-cleaning');
        },
        'hosting-entertaining': function (a, b) {
            return +$(b).data('hosting-entertaining') - +$(a).data('hosting-entertaining');
        },
        // second column
        versatility (a, b) {
            return +$(b).data('versatility') - +$(a).data('versatility');
        },
        'strength-value': function (a, b) {
            return +$(b).data('strength-value') - +$(a).data('strength-value');
        },
        scent (a, b) {
            return +$(b).data('scent') - +$(a).data('scent');
        },
        kids (a, b) {
            return +$(b).data('kids') - +$(a).data('kids');
        },
        pets (a, b) {
            return +$(b).data('pets') - +$(a).data('pets');
        },
        'back-yard': function (a, b) {
            return +$(b).data('back-yard') - +$(a).data('back-yard');
        },
    };

    $('#dropdown-sortby li').on('click', function () {
        const $this = $(this);
        const sort = $this.data('sort');
        const text = $this.html();
        // console.log('sort option chosen: '+sort);
        // console.log('sort text: '+text);
        const $parent = $(this).closest('.menu-filter');
        closePopup($parent);

        $('.sortby-current').html(text);
        $('.js-cta').hide();
        const $container = $('.tile-list');
        $container.find('article').sort(sortFunctions[sort]).appendTo($container);
        $('.howto-user-promo').appendTo($container);
    });

    // open menu by keyboard
    $('#dropdown-sortby li').on('keydown', function (e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
            // return key
            e.preventDefault();
            const $this = $(this);
            const sort = $this.data('sort');
            const text = $this.html();
            // console.log('sort option chosen: '+sort);
            // console.log('sort text: '+text);
            const $parent = $(this).closest('.menu-filter');
            closePopup($parent);

            $('.sortby-current').html(text);
            $('.js-cta').hide();
            const $container = $('.tile-list');
            $container.find('article').sort(sortFunctions[sort]).appendTo($container);
            $('.howto-user-promo').appendTo($container);
            return false;
        }
        return undefined;
    });

    // On CTA click, sort by fan how tos and scroll to the top
    $('.js-show-user-howtos').on('click', (e) => {
        e.preventDefault();
        const $container = $('.tile-list');
        $container.find('article').sort(sortFunctions.fan).appendTo($container);
        $('.howto-user-promo').appendTo($container);
        $('.js-cta').hide();
        $('html, body').animate(
            {
                scrollTop: $('.tile-list').offset().top - 100,
            },
            'fast'
        );
    });
});
